import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'
import HubspotBanner from './HubspotBanner'
import HubspotAdvisor from './HubspotAdvisor'
import HubspotHQ from './HubspotHQ'
import HubspotMatches from './HubspotMatches'
import HubspotBannerAlt from './HubspotBannerAlt'

export default function HubspotShell({ fields, index }: LosseFlexShellProps) {
  const types: LosseFlexShellType = {
    hubspot_banner: HubspotBanner,
    hubspot_banner_alt: HubspotBannerAlt,
    hubspot_advisor: HubspotAdvisor,
    hubspot_hq: HubspotHQ,
    hubspot_matches: HubspotMatches
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}
